import { render, staticRenderFns } from "./IconCard.vue?vue&type=template&id=35f1538b&scoped=true&"
import script from "./IconCard.vue?vue&type=script&lang=js&"
export * from "./IconCard.vue?vue&type=script&lang=js&"
import style0 from "./IconCard.vue?vue&type=style&index=0&id=35f1538b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f1538b",
  null
  
)

export default component.exports